// extracted by mini-css-extract-plugin
module.exports = {"optional":"style__optional__o-IWM","label":"style__label__R3lXq"};